import { React } from 'mondrian-react';
import { useResults } from '../../hooks/results';
import { useLoader } from '../../hooks/loader';
import DefaultLayout from '../_layouts/default';
import Search from './components/Search';
import Results from './components/Results';
import getSearch from '../../services/Api-Gateway';
const { useState } = React;

function Main() {
  const [term, setTerm] = useState('');
  const [searched, setSearched] = useState(false);
  const { setText, index, setIndex, info, setInfo } = useResults();
  const { setLoading } = useLoader();

  const handleSearch = async () => {
    if (term.trim().length > 0) {
      setLoading(true);
      setInfo('');
      setText(term.trim());
      setTerm(term.trim());

      const search = await getSearch(index, term.trim());
      setInfo(search);
      setSearched(true);
      setLoading(false);
    } else {
      setTerm(term.trim());
      setText('');
    }
  };

  const handleKeyPress = (e) => {
    e.stopPropagation();

    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const handleButtonPress = (e) => {
    handleSearch();
  };

  const selectIndex = (e) => {
    setIndex(e.target.value);

    setTerm(term.trim());
    handleSearch();
  };

  return (
    <DefaultLayout>
      <main>
        {!info && !searched ? (
          <Search
            term={term}
            handleKeyPress={handleKeyPress}
            handleButtonPress={handleButtonPress}
            onChange={setTerm}
            index={index}
            selectIndex={selectIndex}
          />
        ) : (
          <Results
            term={term}
            handleKeyPress={handleKeyPress}
            handleButtonPress={handleButtonPress}
            onChange={setTerm}
            index={index}
            selectIndex={selectIndex}
          />
        )}
      </main>
    </DefaultLayout>
  );
}

export default Main;
